// React and related hooks
import React, { Fragment, useEffect, useRef, useState } from 'react';
import Api from '../../../../Services/Api';

// MUI components and hooks
import { Container, Grid, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

// External libraries
import { Helmet } from 'react-helmet';
import '@splidejs/react-splide/css';

// Project components
import { Header } from '../../../../Components/Header';
import Footer from '../../../../Components/Footer';
import StudentsFeedbackSection from '../../../../Components/Sections/StudentsFeedback';
import FirstSectionFullScreen2025 from '../../../../Components/Sections/FirstSectionFullScreen-2025';

// Local components
import ToggleContainerOnline251 from './components/TroggleContainerOnline25-1';
import CounterDown from '../componentes/CounterDown';
import moment from 'moment/moment';

import backgroundImageDesktop from './assets/bg-first-section-arena-hwm-25-1.png';
import backgroundImageMobile from './assets/bg-first-section-arena-hwm-25-1-mobile.png';
import bgVozesDesktop from './assets/vozes-desktop.png';
import bgVozesMobile from './assets/vozes-mobile.png';

import bgReviseDesktopImg1 from './assets/bg-revise-img1-desktop.png';
import bgReviseDesktopImg2 from './assets/bg-revise-img2-desktop.png';
import bgReviseMobileImg1 from './assets/bg-revise-img1-mobile.png';
import bgReviseMobileImg2 from './assets/bg-revise-img2-mobile.png';

import logoArena20251 from './assets/logo-arena-default-2025-1.svg';
import PurchaseCard20251 from './components/PurchaseCard-2025-1';
import { MainTitle, MainTitleV2 } from './components/PurchaseCard-2025-1.style';
import PurchaseCard20251WaitingList from './components/PurchaseCard-2025-1-WaitingList';
import PurchaseCard20251PresencialWaitList from './components/PurchaseCard-2025-1-Presencial-WaitList';
import InformationAboutClosedArena from './components/InformationsAboutClosedArena';
import QuestionsExperts from '../../../../Components/Sections/QuestionsExperts';
import StationsTraining from '../../../../Components/Sections/StationsTraining';

import imgContainer1 from '../Arena/assets/container-1.png';
import imgContainer2 from '../Arena/assets/container-2.png';

import imgContainerMob1 from '../Arena/assets/container-mobile-1.png';
import imgContainerMob2 from '../Arena/assets/container-mobile-2.png';
import Comparison from '../../../../Components/Sections/Comparison';

import ThirdSection from '../componentes/ThirdSection';
import bgApostas01 from '../Arena/assets/bg-apostas-01.png';
import bgApostas02 from '../Arena/assets/bg-apostas-02.png';

import ContainerApostas from './components/ContainerApostas';

export default function ArenaSale20251Presencial() {
	const classes = useStyles();
	const theme = useTheme();
	const arena_card = useRef(null);
	const arena_purchase_card = useRef(null);

	const matchesMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const matchesTablet = useMediaQuery(theme.breakpoints.down('md'));

	const [currentLot, setCurrentLot] = useState([]);
	const [totalValue, setTotalValue] = useState(0);
	const [fullObj, setFullObj] = useState([]);
	const [isOpenToSubscription, setIsOpenToSubscription] = useState(true);
	const [isLoading, setIsLoading] = useState(false);

	const executeScroll = () =>
		arena_card.current.scrollIntoView({ behavior: 'smooth', block: matchesTablet ? 'start' : 'center' });

	useEffect(() => {
		setIsLoading(true);
		const fetchData = async () => {
			await Api.get(`turmasabertas/${1468}`)
				.then((res) => {
					if (res) {
						setFullObj(res[0]);

						const data_hoje = moment(new Date()).format();

						const current_lot = res[0]?.lotes?.filter(
							(lot) =>
								data_hoje > moment(lot?.data_inicio).format() &&
								data_hoje < moment(lot?.data_limite).format()
						);

						if (current_lot?.length > 0) {
							setCurrentLot(current_lot);
							setIsOpenToSubscription(true);
						} else {
							setIsOpenToSubscription(false);
						}
					}
				})
				.finally(() => {
					setIsLoading(false);
				});
		};

		fetchData();
	}, []);

	const targetDate = new Date(currentLot[0]?.data_limite);

	return (
		<Container
			maxWidth={false}
			disableGutters={true}
			style={{ backgroundColor: '#0D0D0D' }}
		>
			{/* {!isLoading && (
				<CounterDown
					date={targetDate}
					text={'O primeiro lote se encerra em…'}
					textMobile={'O primeiro lote se encerra em…'}
					colorStartButton={'#09D785'}
					colorEndButton={'#098CAF'}
					btnText="Aproveite!"
					scrollToPayment={executeScroll}
				/>
			)} */}
			<Helmet>
				<title>Arena Hardwork | Domine a Nova Prova Prática do Revalida INEP</title>
				<meta
					name="description"
					content="Prepare-se para a nova prova prática do Revalida INEP com a Arena
Hardwork. A prática que você precisa para conquistar sua aprovação!"
				/>
			</Helmet>
			{matchesMobile ? null : matchesTablet ? <Header /> : null}
			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className="revalida"
			>
				{matchesMobile || matchesTablet ? null : <Header />}
			</Container>
			<Grid
				container
				className="revalida"
			>
				<FirstSectionFullScreen2025
					backgroundImageUrlDesktop={backgroundImageDesktop}
					backgroundImageUrlMobile={backgroundImageMobile}
					logoUrl={logoArena20251}
					type="green"
					buttonText="Garanta sua vaga!"
					executeScroll={executeScroll}
					firstTextPaper={[
						<Typography
							variant="h1"
							fontFamily={'var(--font-bebas)'}
							className={`${classes.gradientText}`}
						>
							SEJA{' '}
							<span
								className={`${classes.gradientText} gradient-text`}
								style={{ display: 'inline' }}
							>
								IMBATÍVEL
							</span>{' '}
							<br />
							NA PROVA PRÁTICA
							<br /> DO REVALIDA INEP
						</Typography>,
					]}
					buttonProps={{
						bottom: '7.5em',
						left: '5em',
						type: 'white-btn',
						color: 'secondary',
						buttonLogoUrl: require('../../../../Assets/Svg/Icons/bagIcon.svg').default,
					}}
					imageProps={{ width: '37%', left: '10em', top: '5.75em' }}
				/>
			</Grid>

			<Comparison />

			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className={'revalida'}
			>
				<ThirdSection />
			</Container>

			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
				className={'revalida'}
			>
				<Grid
					container
					className="section"
					style={{ margin: '0 auto' }}
				>
					<MainTitleV2>Revise com foco e conquiste a sua aprovação</MainTitleV2>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: 40,
						}}
					>
						<ContainerApostas
							title={'Apostas Hardwork para a prova prática'}
							bgImg={bgApostas01}
							content={
								'Vídeos gravados pelos professores Hardwork apostando em como os principais temas podem ser cobrados na prova prática. A assertividade que o Hardwork tem na teórica, aplicada na prática!'
							}
						/>

						<ContainerApostas
							title={'Revisões cíclicas personalizadas com flashcards Hardwork'}
							bgImg={bgApostas02}
							reverse={true}
							content={
								'Teoria é a base da prova prática! Revisões cíclicas e personalizadas, com os flashcards Hardwork. Revise mais o que você tem mais dificuldade!'
							}
						/>
					</div>
				</Grid>
			</Container>

			<StationsTraining />

			<QuestionsExperts />

			<ToggleContainerOnline251
				targetDate={targetDate}
				arena_card={arena_purchase_card}
				arena_purchase_card={arena_purchase_card}
				executeScroll={executeScroll}
			/>
			<Grid
				ref={arena_card}
				style={{ backgroundColor: '#09D785' }}
				boxShadow={'inset 0 40em 30em rgba(25, 25, 25, 1)'}
			>
				<Container
					fixed
					maxWidth="xl"
					disableGutters={true}
					className={'revalida'}
				>
					<Grid
						container
						item
						className="section"
						justifyContent={'space-between'}
						alignItems={'center'}
						style={{ margin: '0 auto' }}
					>
						{isOpenToSubscription ? (
							<MainTitle>Garanta sua inscrição!</MainTitle>
						) : (
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'start',
									paddingTop: 10,
								}}
							>
								<MainTitle style={{ fontSize: '48px', lineHeight: '40px' }}>
									Abertura de inscrições
								</MainTitle>
								<MainTitle style={{ fontSize: '40px', lineHeight: '35px' }}>
									em 08/04/2025 às 20h25
								</MainTitle>
							</div>
						)}
						<Tooltip
							placement={'top'}
							title={`
                                *Válido apenas para ex-alunos Arena Hardwork 24.2 regulares!
                                *50% de desconto aplicado sob o valor total do curso.	
                            `}
						>
							<div
								style={{
									fontFamily: 'Manrope',
									fontSize: '12px',
									fontWeight: 600,
									backgroundColor: '#656565',
									padding: '8px 16px',
									borderRadius: '16px',
									color: 'white',
								}}
							>
								50% OFF para ex-alunos Arena 24.2*
							</div>
						</Tooltip>
					</Grid>
					<Grid
						container
						className="section"
						style={{ margin: '0 auto' }}
						gap={4}
						alignItems={'start'}
						justifyContent={'center'}
						flexWrap={matchesMobile ? 'wrap' : 'nowrap'}
						paddingY={5}
					>
						{!isLoading && isOpenToSubscription ? (
							<PurchaseCard20251
								turma={1468}
								type={'Online'}
								subtitle={'Treinamento na plataforma Hardwork Medicina'}
								available={true}
								description={
									<Fragment>
										Inscreva-se antecipadamente:
										<br /> - Acesso <strong>imediato¹</strong> aos casos temáticos;
										<br />- Acesso ao conteúdo completo a partir de <strong>08/04/25</strong>.
									</Fragment>
								}
								originalPrice={fullObj?.valor}
								qtdParcelas={fullObj?.max_parcelas}
								valorParcela={currentLot[0]?.valor / fullObj?.max_parcelas}
								valorAVista={currentLot[0]?.valor}
							/>
						) : (
							<PurchaseCard20251WaitingList
								turma={1468}
								agroupment={'LISTA ESPERA ARENA ONLINE 2025.1'}
								type={'Online'}
								subtitle={'Treinamento na plataforma Hardwork Medicina'}
								description={
									<Fragment>
										<br />
										<span style={{ fontSize: '16px', color: '#CCCCCC' }}>
											Seja avisado sobre a abertura de inscrições com a
										</span>
										<br />
										<strong
											style={{
												fontSize: '48px',
												lineHeight: '48px',
												textTransform: 'uppercase',
												color: 'white',
												fontFamily: 'Manrope',
											}}
										>
											Lista de espera
										</strong>
									</Fragment>
								}
							/>
						)}
						<PurchaseCard20251PresencialWaitList
							turma={1468}
							agroupment={'LISTA ESPERA ARENA PRESENCIAL 2025.1'}
							type={'Presencial'}
							subtitle={'Treinamento presencial em São Paulo'}
							available={false}
							description={<InformationAboutClosedArena />}
						/>
						{/*	Jansen*/}
					</Grid>
				</Container>
			</Grid>

			<StudentsFeedbackSection type="arena 2022" />

			<Container
				fixed
				maxWidth="xl"
				disableGutters={true}
			>
				<Footer />
			</Container>
		</Container>
	);
}

const useStyles = makeStyles((theme) => ({
	text: {
		fontSize: '1.75rem !important',
		lineHeight: '1.25 !important',
		[theme.breakpoints.down('xl')]: {
			fontSize: '1.35rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.9rem !important',
		},
	},
	backgroundWaves: {
		backgroundImage: `url(${process.env.PUBLIC_URL + '/Assets/Img/bgWave2.png)'}`,
		width: '100vw !important',
	},
	gradientText: {
		color: '#FFF',
		fontSize: '3.5rem !important',
		fontWeight: 'normal !important',
		lineHeight: 'unset !important',
		[theme.breakpoints.down('md')]: {
			fontSize: '3rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '2.5rem !important',
		},
	},
	timerGrid: {
		position: 'fixed',
		bottom: '2rem',
		zIndex: 3,
		border: '3px solid #ffffff',
		margin: '0 auto !important',
		backgroundColor: '#000000d9',
		padding: '0.75rem 8rem 0.75rem 4rem',
		borderRadius: '25px 50px 50px 25px !important',
		[theme.breakpoints.down(1770)]: {
			padding: '0.75rem 8rem 0.75rem 4rem',
		},
		[theme.breakpoints.down(1240)]: {
			padding: '0.75rem 9rem 0.75rem 4rem',
		},
		[theme.breakpoints.down('md')]: {
			padding: '0.75rem 2rem 0.75rem 3rem',
			borderRadius: '15px !important',
		},
		[theme.breakpoints.down('sm')]: {
			padding: '0.75rem 1rem',
		},
	},
	endOfDiscount: {
		fontSize: '1.25rem !important',
		alignSelf: 'center',
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.7rem !important',
		},
	},
	timeText: {
		fontSize: '3.85rem !important',
		lineHeight: 'unset !important',
		color: 'yellow !important',
		[theme.breakpoints.down('xl')]: {
			fontSize: '2.5rem !important',
			alignSelf: 'center',
		},
		[theme.breakpoints.down('md')]: {
			fontSize: '3rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.5rem !important',
		},
	},
	timerIcon: {
		position: 'absolute',
		right: -14,
		top: -22,
		[theme.breakpoints.down('xl')]: {
			top: -20,
			right: -11,
			width: '10%',
		},
		[theme.breakpoints.down(1770)]: {
			top: -30,
			right: -15,
			width: 'unset',
		},
		[theme.breakpoints.down(1535)]: {
			top: -27,
			right: -13,
			width: '12%',
		},
		[theme.breakpoints.down(1416)]: {
			top: -22,
			right: -12,
			width: '12%',
		},
		[theme.breakpoints.down(1240)]: {
			top: -22,
			right: -13,
			width: '14%',
		},
		[theme.breakpoints.down(1190)]: {
			width: '12%',
		},
		[theme.breakpoints.down(1060)]: {
			width: '13%',
			top: -19,
			right: -11,
		},
		[theme.breakpoints.down(941)]: {
			width: '15%',
		},
		[theme.breakpoints.down('md')]: {
			display: 'none',
		},
	},
	timeTextDescription: {
		fontWeight: 'bold !important',
		fontSize: '0.85rem !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.45rem !important',
		},
	},
	containerTime: {
		backgroundColor: '#ffffff2b',
		borderRadius: '6px',
		color: '#ffffff',
		width: '5rem !important',
		height: '4rem',
		[theme.breakpoints.down(1770)]: {
			width: '3.5rem !important',
			height: '3.5rem',
		},
		[theme.breakpoints.down('sm')]: {
			width: '2rem !important',
			height: '2.5rem',
		},
	},
	textNumber: {
		fontWeight: 'bold !important',
		fontSize: '1.4rem !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '1rem !important',
		},
	},
	containerSeparator: {
		color: '#ffffff',
		width: '2.2rem !important',
		height: '3.8rem',
		[theme.breakpoints.down('sm')]: {
			width: '1.2rem !important',
			height: '2.5rem',
		},
	},
	separatorText: {
		fontWeight: 'bold !important',
		fontSize: '1.3rem !important',
		[theme.breakpoints.down('sm')]: {
			fontSize: '0.9rem !important',
		},
	},
	textTimer: {
		textTransform: 'uppercase',
		fontWeight: 'bold !important',
		width: '5rem !important',
		height: '1rem',
		fontSize: '0.75rem !important',
		alignSelf: 'center',
		[theme.breakpoints.down(1770)]: {
			width: '4rem !important',
		},
		[theme.breakpoints.down(1240)]: {
			width: '3.5rem !important',
		},
		[theme.breakpoints.down('sm')]: {
			width: '2rem !important',
			fontSize: '0.5rem !important',
		},
	},
}));
